import type { ProjectTab } from 'src/enums/project-tab'

const POST_PUBLISH_TABS: ProjectTab[] = ['work-assignments', 'batch-numbers']

// Positions is the project root, so any path that isn't a post-publish tool belongs to it.
export const getActiveProjectTab = (pathname: string): ProjectTab =>
  POST_PUBLISH_TABS.find(tab => new RegExp(`/project/[^/]+/${tab}(/|$)`).test(pathname)) ?? 'positions'
